import React from "react";
import { PersonContact } from "../../models/person/Person";
import { isNullOrWhiteSpace } from "../../shared/string";
import { ContactPerson } from "../ContactPerson";
import { HelpCardType } from "./HelpCard";
import HelpCardContainer, { Props as ContainerProps } from "./HelpCardContainer";

export type SanityHelpCardIRContact = {
  _type: HelpCardType.IRContact;
  title: string;
  preamble: string;
  contacts: PersonContact[];
};

export interface HelpCardIRContactProps extends ContainerProps, SanityHelpCardIRContact {}

const HelpCardIRContact = (props: HelpCardIRContactProps) => {
  const { title, preamble, contacts, ...containerProps } = props;

  return (
    <HelpCardContainer {...containerProps} roundedClassName="rounded-lg">
      {!isNullOrWhiteSpace(title) && (
        <>
          <h3 className="font-bold text-neutral-100 mb-4">{title}</h3>
          <hr className="h-divider-thick w-16 bg-neutral-100 mb-4 lg:mb-6" />
        </>
      )}
      {!isNullOrWhiteSpace(preamble) && (
        <p className="mb-10 text-neutral-100 lg:pr-6">{preamble}</p>
      )}
      <ul>
        {contacts?.map((contact, index) => (
          <ContactPerson key={index} textColor="light" {...contact} />
        ))}
      </ul>
    </HelpCardContainer>
  );
};

export default HelpCardIRContact;

